import { computed } from 'mobx';
import Model from 'core/model/Model';

class GlobalFilterModel extends Model {
  get defaults() {
    return {
      name: '',
      description: '',
      scope: {
        dimensions: { all_devices: false, sites: [], labels: [], device_types: [], devices: [] },
        filters: null
      }
    };
  }

  get urlRoot() {
    return '/api/ui/rbux/scopes';
  }

  get omitDuringSerialize() {
    return ['company_id', 'created_by', 'cdate', 'edate'];
  }

  get messages() {
    return {
      create: 'Global filter added successfully',
      update: 'Global filter updated successfully',
      destroy: 'Global filter removed successfully'
    };
  }

  @computed
  get dimensions() {
    return this.get('scope')?.dimensions ?? {};
  }

  @computed
  get siteIds() {
    return this.dimensions.sites ?? [];
  }

  @computed
  get labelIds() {
    return this.dimensions.labels ?? [];
  }

  @computed
  get deviceTypes() {
    return this.dimensions.device_types ?? [];
  }

  @computed
  get deviceIds() {
    return this.dimensions.devices ?? [];
  }

  /**
   * A scope with no dimensions is unrestricted, so it's treated the same as an
   * explicit "entire network" selection.
   */
  @computed
  get isAllDevices() {
    return this.dimensions.all_devices === true || this.selectionCount === 0;
  }

  @computed
  get assetTags() {
    return this.dimensions.asset_tags ?? [];
  }

  @computed
  get filters() {
    return this.get('scope')?.filters ?? null;
  }

  /**
   * Number of dimension/filter selections making up the scope. Used to tell an
   * empty (company-wide) global filter apart from a configured one.
   */
  @computed
  get selectionCount() {
    const numFilterGroups = this.filters?.filterGroups?.length ?? 0;
    return (
      this.siteIds.length +
      this.labelIds.length +
      this.deviceTypes.length +
      this.deviceIds.length +
      this.assetTags.length +
      numFilterGroups
    );
  }
}

export default GlobalFilterModel;
